import { IconButton, Toolbar, Tooltip, styled, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import { IconFilter, IconBackspace, IconCirclePlus } from '@tabler/icons-react'
import SearchIcon from '@mui/icons-material/Search'
import { useDebounce } from 'use-debounce'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from '../../../../store/store'
import { dialogToggle } from '../../../../store/slices/dialog'
import { Search, StyledInputBase } from '../../../../config'
import { setCustomerNameFilterQuerySearch } from '../../../../store/slices/filters/filters'
import { CustomerFilterDrawer } from './customerFilterDrawer/customerFilterDrawer'

export const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const RemoveSearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const CustomerEnhancedTableToolbar = () => {
  const dispatch = useDispatch()
  const theme = useTheme()
  const navigate = useNavigate()

  const [drawerOpen, setDrawerOpen] = useState(false)
  const { customerNameFilterQuerySearch } = useSelector((state) => state.filters)
  const [searchValue, setSearchValue] = useState(customerNameFilterQuerySearch || '')
  const [debouncedSearchValue] = useDebounce(searchValue, 300)

  const handleOpen = () => {
    dispatch(dialogToggle(true))
    navigate({ search: 'create' })
  }

  useEffect(() => {
    dispatch(setCustomerNameFilterQuerySearch(debouncedSearchValue))
  }, [debouncedSearchValue, dispatch])

  useEffect(() => {
    if (window.location.search) {
      dispatch(dialogToggle(true))
    }
  }, [dispatch])

  return (
    <>
      <Toolbar>
        <Search sx={{ flex: '1 1 100%', display: 'flex', alignContent: 'baseline' }}>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            onChange={(e) => setSearchValue(e.target.value)}
            value={searchValue}
            placeholder="Search…"
            inputProps={{ 'aria-label': 'search' }}
            autoFocus
          />
          {customerNameFilterQuerySearch && (
            <RemoveSearchIconWrapper
              onClick={() => {
                dispatch(setCustomerNameFilterQuerySearch(''))
              }}
            >
              <IconBackspace size="24px" className="removeIcon" />
            </RemoveSearchIconWrapper>
          )}
        </Search>
        <Tooltip onClick={() => setDrawerOpen(!drawerOpen)} title="Filter list">
          <IconButton>
            <IconFilter size="20px" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Add new" onClick={handleOpen}>
          <IconButton>
            <IconCirclePlus
              stroke="none"
              size="35px"
              fill={theme.palette.primary.main}
              color={theme.palette.primary.light}
            />
          </IconButton>
        </Tooltip>

        <CustomerFilterDrawer drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
      </Toolbar>
    </>
  )
}
